/**
 * @param uid
 * @param index
 * @param indexes
 * @param documents
 * @returns {(function(*, []=): (*[]))|*}
 */
export function initSearchHandler({uid, index, indexes = [index], documents = []}) {
  return (value, docs = documents) => {
    if (!value.trim()) return docs;
    const keywords = value
      .trim()
      .split(' ')
      .map(x => x.toUpperCase())
      .filter(Boolean);

    const result = [];
    docs.forEach(document => {
      if (result.some(x => x[uid] === document[uid])) return;

      const data = indexes.map(index => (document[index] || '').toUpperCase());
      const isMatch = keywords.some(keyword => data.some(datum => datum.includes(keyword)));
      if (isMatch) result.push(document);
    });
    return result;
  };
}

function hasMatch(list, text) {
  return list.some(item => new RegExp(text, 'i').test(item));
}

function initSearchByWordHandler({uid, index, indexes = [index], documents = []}) {
  return (value, docs = documents) => {
    const fullText = value.trim();
    if (!fullText) return docs;
    const keywords = fullText.split(/\s+/);

    const calculateRelevance = list => {
      if (hasMatch(list, fullText)) return 2;
      if (keywords.every(keyword => hasMatch(list, keyword))) return 1;
      return 0;
    };

    const results = [];
    const addedIds = new Set();

    docs.forEach(document => {
      const list = indexes.map(index => document[index] || '');
      const relevance = calculateRelevance(list);
      if (!relevance || addedIds.has(document[uid])) return;

      results.push({...document, relevance});
      addedIds.add(document[uid]);
    });

    return results.sort((a, b) => b.relevance - a.relevance);
  };
}

export function faqSearchByWordHandler(
  uid = 'questionId',
  indexes = ['question', 'textAnswer'],
  documents = []
) {
  return initSearchByWordHandler({uid, indexes, documents});
}

/**
 * Prioritizes search results by matching the key with the search result
 * @param {Array} options - The array of options to prioritize
 * @param {Array} searchResult - The array of search results
 * @param {string} key - The key to prioritize by
 * @returns {Array} The prioritized array
 */
export const prioritizeSearchResults = (options, searchResult, key = 'countryCode') => {
  return [...options].sort((a, b) => {
    const aMatches = searchResult.some(item => item[key] === a[key]);
    const bMatches = searchResult.some(item => item[key] === b[key]);
    if (aMatches && !bMatches) return -1;
    if (!aMatches && bMatches) return 1;
    return 0;
  });
};
